import { BackgroundStylesInterface } from 'common/types/background-interfaces'
import { TFunction } from 'i18next'
import {
  BackgroundPositionType,
  BackgroundVariantsType,
  backGroundPositionLocoKeys,
  backgroundPositions,
  backgroundPositionValues,
  backgroundVariants,
} from 'src/editor/shared/constants/background-consts'

export const getBackgroundPositionOptions = (
  isLecture: boolean,
  t: TFunction,
) => {
  const hideFixed = isLecture

  return [
    getBackgroundPositionOption(backgroundVariants.Default, t),
    /*
     * NOTE: the iframe in the user-domain project (course lectures) doesn't support "background-attachment: fixed"
     */
    ...(!hideFixed
      ? [getBackgroundPositionOption(backgroundVariants.Fixed, t)]
      : []),
    getBackgroundPositionOption(backgroundVariants.Repeat, t),
    getBackgroundPositionOption(backgroundVariants.Width100, t),
    getBackgroundPositionOption(backgroundVariants.Width100Height100, t),
    getBackgroundPositionOption(backgroundVariants.ScalesWithoutCropping, t),
  ]
}

export const getBackgroundPositionOption = (
  position: BackgroundVariantsType,
  t: TFunction,
) => {
  return {
    label: t(backGroundPositionLocoKeys[position] ?? position),
    value: position,
  }
}

////

export const detectBackgroundType = (
  position?: BackgroundStylesInterface,
  isLecture?: boolean,
): BackgroundVariantsType => {
  if (position) {
    if (position.backgroundAttachment === 'fixed') {
      /*
       * NOTE: the iframe in the user-domain project (course lectures) doesn't support "background-attachment: fixed"
       */
      return isLecture
        ? backgroundVariants.Width100Height100
        : backgroundVariants.Fixed
    }
    if (
      position.backgroundRepeat === 'repeat' ||
      position.backgroundRepeat !== 'no-repeat'
    ) {
      return backgroundVariants.Repeat
    }
    switch (position.backgroundSize) {
      case '100%':
        return backgroundVariants.Width100
      case 'cover':
        return backgroundVariants.Width100Height100
      case 'contain':
        return backgroundVariants.ScalesWithoutCropping
    }
  }
  return backgroundVariants.Default
}

export const detectBackgroundPositionType = (
  position?: BackgroundStylesInterface,
): BackgroundPositionType => {
  if (!position?.backgroundPosition) {
    return backgroundPositions.CenterCenter
  }

  for (const [key, value] of Object.entries(backgroundPositionValues)) {
    if (value === position.backgroundPosition) {
      return key as BackgroundPositionType
    }
  }

  return backgroundPositions.CenterCenter
}
